module.exports = __webpack_public_path__ + "img/qgjj-05.prt.cac48331.jpg";